document.addEventListener("DOMContentLoaded", function () {
    if (typeof lax !== 'undefined') {
        lax.init();

        // Add a driver that we use to control our animations
        lax.addDriver('scrollY', function () {
            return window.scrollY;
        });

        // Add animation bindings to elements
        lax.addElements('.wwc-1', {
            scrollY: {
                translateY: [
                    ["elInY", "elCenterY", "elOutY"],
                    {
                        500: [300, 0, 0],
                        1400: [400, 100, -200],
                    }
                ],
                scale: [
                    ["elInY", "elCenterY", "elOutY"],
                    {
                        500: [0.9, 1, 1],
                        1400: [0.9, 1.1, 0.8],
                    }
                ]
            }
        });

        lax.addElements('.wwc-2', {
            scrollY: {
                translateY: [
                    ["elInY", "elCenterY", "elOutY"],
                    {
                        500: [120, 0, 0],
                        1400: [250, -70, -400],
                    }
                ],
                scale: [
                    ["elInY", "elCenterY", "elOutY"],
                    {
                        500: [0.9, 1, 1],
                        1400: [0.9, 1.1, 0.8],
                    }
                ]
            }
        });

        lax.addElements('.wwc-3', {
            scrollY: {
                translateY: [
                    ["elInY", "elCenterY", "elOutY"],
                    {
                        500: [100, 0, 0],
                        1400: [50, -220, -700],
                    }
                ],
                scale: [
                    ["elInY", "elCenterY", "elOutY"],
                    {
                        500: [0.9, 1, 1],
                        1400: [0.9, 1.1, 0.8],
                    }
                ]
            }
        });
    } else {
        console.warn("Lax.js not loaded");
    }
});
